<button
  id="add-to-favorite-component-button1"
  class="p-bottom-float-function-icon__btn p-bottom-float-function-icon__btn--favorite js-add-to-favorite-btn"
  title="{{ 'label.addFavorite1' | staticMsg }}"
  (throttleClick$)="this.clickFavorite($event)"
  [disabled]="this.disabled"
  aswThrottleClick
>
  <span class="p-bottom-float-function-icon__add-to-favorite js-add-to-favorite-icon" #animationPoint></span>
</button>
